const config = {
	'apiBaseURL': 'https://hydro.11zz.club/api/v1',
	'persistentStorageName': 'hydro-admin-store',
	'debugApiError': false
}

export default config